// extracted by mini-css-extract-plugin
export default {"main":"_6eb3a7cee9 _2879687bb2","xmark":"_08fb00418b","fl_img":"_099e0a449d _5f5f62f2b2"};